"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanySubscriptionBlock = CompanySubscriptionBlock;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const icons_1 = require("@ant-design/icons");
const Api = __importStar(require("@src/api"));
const uuid = __importStar(require("uuid"));
const elements_1 = require("@src/components/elements");
const auth_context_1 = require("@src/context/auth-context");
const react_intl_1 = require("react-intl");
const account_context_1 = require("@src/context/account-context");
const antd_1 = require("antd");
const streamline_icon_check_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-check.svg"));
const streamline_icon_add_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-add.svg"));
const CompanySubscriptionBlock_style_1 = require("./CompanySubscriptionBlock.style");
function CompanySubscriptionBlock({ subscribers, companyId }) {
    const [subscribersLocal, setSubscribersLocal] = react_1.default.useState(subscribers);
    const [isLoading, setIsLoading] = react_1.default.useState(false);
    const user = (0, account_context_1.useAccount)();
    const shouldDisableSubscribeButton = (user === null || user === void 0 ? void 0 : user.companyId) === companyId;
    const { checkAuthentication } = (0, auth_context_1.useAuthContextValue)();
    const isSubscribedToCompany = react_1.default.useMemo(() => Boolean(subscribersLocal === null || subscribersLocal === void 0 ? void 0 : subscribersLocal.find(c => c.account_id === (user === null || user === void 0 ? void 0 : user.id))), [subscribersLocal]);
    const intl = (0, react_intl_1.useIntl)();
    const toggleSubscription = async () => {
        try {
            setIsLoading(true);
            await checkAuthentication();
            await Api.Company.toggleCompanySubscription(companyId);
            if (isSubscribedToCompany) {
                setSubscribersLocal(subscribersLocal.filter(s => s.account_id !== (user === null || user === void 0 ? void 0 : user.id)));
            }
            else {
                setSubscribersLocal([...subscribersLocal, { account_id: user === null || user === void 0 ? void 0 : user.id, company_id: companyId }]);
            }
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setIsLoading(false);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(CompanySubscriptionBlock_style_1.BottomGroup, { children: [(0, jsx_runtime_1.jsx)("div", { children: subscribersLocal && subscribersLocal.length > 0 && ((0, jsx_runtime_1.jsx)(antd_1.Avatar.Group, { maxCount: 1, size: "small", maxStyle: { color: '#f56a00', backgroundColor: '#fde3cf' }, children: subscribersLocal === null || subscribersLocal === void 0 ? void 0 : subscribersLocal.map((_, index) => ((0, jsx_runtime_1.jsx)(antd_1.Avatar, { style: { backgroundColor: ['#f56a00'][index] }, icon: (0, jsx_runtime_1.jsx)(icons_1.UserOutlined, {}) }, uuid.v4()))) })) }), (0, jsx_runtime_1.jsxs)(elements_1.Button, { className: "m-l-s", loading: isLoading, size: "small", shape: "round", onClick: () => toggleSubscription(), disabled: shouldDisableSubscribeButton, icon: isSubscribedToCompany ? ((0, jsx_runtime_1.jsx)(streamline_icon_check_svg_1.default, { className: "m-r-xs", width: 10 })) : ((0, jsx_runtime_1.jsx)(streamline_icon_add_svg_1.default, { className: "m-r-xs", width: 10 })), children: [!isSubscribedToCompany && ((0, jsx_runtime_1.jsx)("span", { children: intl.formatMessage({ id: 'companies_list.subscription.subscribe' }) })), isSubscribedToCompany && ((0, jsx_runtime_1.jsx)("span", { children: intl.formatMessage({ id: 'companies_list.subscription.unsubscribe' }) }))] })] }));
}
